import { render, staticRenderFns } from "./RequestDetailForm.vue?vue&type=template&id=0a0db93a&scoped=true"
import script from "./RequestDetailForm.vue?vue&type=script&lang=ts"
export * from "./RequestDetailForm.vue?vue&type=script&lang=ts"
import style0 from "./RequestDetailForm.vue?vue&type=style&index=0&id=0a0db93a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a0db93a",
  null
  
)

export default component.exports